import { Breadcrumb, Layout, Menu, Image, Row, Col, Button, message, Upload, Card, Input } from 'antd';
import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom'
import { InboxOutlined, HeartOutlined } from '@ant-design/icons';
const AboutMercy = () => {
    return (
        <>
            <Row gutter={[8, 40]}>
                <Col span={24} style={{ fontSize: '60px', textAlign: 'center' }}>Mercy 在哪兒 </Col>
                <Col span={24}>
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3685.927210054195!2d120.38995391494961!3d22.506914041050585!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3471e3fab5f8508b%3A0x4a5db78e890085a5!2sMercy%20English%20Center!5e0!3m2!1szh-TW!2stw!4v1673114630648!5m2!1szh-TW!2stw" width="100%" height="450" style={{ border: 0 }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </Col>
            </Row>
        </>
    )
}
export default AboutMercy;